import React, { useState, useEffect, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  FormLabel,
  Alert,
  Switch,
  Stack,
  Card,
  CardContent,
  Divider,
  AppBar,
  Toolbar,
  Slide,
} from "@mui/material";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Paper,
  Grid,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  ImportExport,
  EventNote,
  Person,
  CloudUpload,
} from "@mui/icons-material";
import ListIcon from "@mui/icons-material/List";
import WatchLaterIcon from "@mui/icons-material/WatchLater";

import PersonIcon from "@mui/icons-material/Person";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";
import EventIcon from "@mui/icons-material/Event";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import StarIcon from "@mui/icons-material/Star";
import { useSelector } from "react-redux";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import WarningIcon from "@mui/icons-material/Warning";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import AttendenceHeader from "./AttendenceHeader";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { LeadAgentsSettingsApi, departmentHRApi, clientApis } from "../../../Data/axios";
import CircularProgress from "@mui/material/CircularProgress";
import config from "../../../Data/AuthUser";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const employees = [
  {
    name: "Sadie Sauer",
    role: "Senior",
    depart: "Public Relations",
    img: "https://i.pravatar.cc/30?u=admin@example.com",
  },
  {
    name: "Tracy Kunze",
    role: "Team Lead",
    depart: "Public Relations",
    img: "https://i.pravatar.cc/30?u=employee@example.com",
  },
  {
    name: "Hermann Lynch",
    role: "Trainee",
    depart: "Sales",
    img: "https://i.pravatar.cc/30?u=simonis.nina@example.net9",
  },
  {
    name: "Norene Schaefer",
    role: "Senior",
    depart: "Finance",
    img: "https://i.pravatar.cc/30?u=fcrooks@example.com4",
  },
  {
    name: "Jarrell Moen Jr.",
    role: "Senior",
    depart: "Sales",
    img: "https://i.pravatar.cc/30?u=jraynor@example.org0",
  },
  {
    name: "Mr. Davonte Spencer",
    role: "Team Lead",
    depart: "Sales",
    img: "https://i.pravatar.cc/30?u=pcrist@example.com9",
  },
  {
    name: "Demarco O'Kon",
    role: "Project Manager",
    depart: "Human Resources",
    img: "https://i.pravatar.cc/30?u=lola01@example.org9",
  },
  {
    name: "Narciso Crona",
    role: "Team Lead",
    depart: "Public Relations",
    img: "https://i.pravatar.cc/30?u=alford.schultz@example.org4",
  },
  {
    name: "Mr. Vern Parisian",
    role: "Senior",
    depart: "Sales",
    img: "https://i.pravatar.cc/30?u=elta.mertz@example.org4",
  },
  {
    name: "Woodrow Gerhold",
    role: "Junior",
    depart: "Public Relations",
    img: "https://i.pravatar.cc/30?u=keeling.halle@example.net5",
  },
  {
    name: "Dr. Milo Veum",
    role: "Trainee",
    depart: "Public Relations",
    img: "https://i.pravatar.cc/30?u=josianne.graham@example.net7",
  },
  {
    name: "Reyna Bayer",
    role: "Trainee",
    depart: "Finance",
    img: "https://i.pravatar.cc/30?u=nicolas.emily@example.net1",
  },
  {
    name: "Eunice Carroll V",
    role: "Senior",
    depart: "Marketing",
    img: "https://i.pravatar.cc/30?u=kiel.zemlak@example.org4",
  },
];

const stats = [
  { title: "Working Days", value: 31 },
  { title: "Days Present", value: 0 },
  { title: "Late", value: 0 },
  { title: "Half Day", value: 0 },
  { title: "Absent", value: 31 },
  { title: "Holidays", value: 0 },
];

// Helper function to calculate days in a month
const getDaysInMonth = (month, year) => {
  return new Date(year, month + 1, 0).getDate();
};

// Helper function to get day names
const getDayName = (date, month, year) => {
  const dayIndex = new Date(year, month, date).getDay();
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return days[dayIndex];
};

// Status configuration mapping (matching the normal attendance implementation)
const statusConfig = {
  "1": { icon: "✓", color: "#4caf50", label: "Present", bgColor: "#e8f5e9" },
  "1603": { icon: "✕", color: "#f44336", label: "Absent", bgColor: "#ffebee" },
  "1610": { icon: "🍃", color: "#333", label: "Leave Request", bgColor: "#f5f5f5" },
  "1612": { icon: "✈", color: "#9c27b0", label: "On Leave", bgColor: "#f3e5f5" },
  "1605": { icon: "🏠", color: "orange", label: "Relieved", bgColor: "#fff3e0" },
  "1_no_loc": { icon: "⌨️", color: "#ff9800", label: "Present (No Location)", bgColor: "#ffe0b2" },
};

// Helper function to format date string
const formatDateString = (monthValue, yearValue, day) => {
  return `${yearValue}-${String(monthValue + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

// Helper function to get attendance for specific date (matching AttendanceClients implementation)
const getAttendanceForDate = (attendanceList, day, monthValue, yearValue) => {
  if (!attendanceList || !Array.isArray(attendanceList)) return null;

  const dateStr = formatDateString(monthValue, yearValue, day);
  return attendanceList.find((a) => a.date === dateStr) || null;
};

const Attendance = () => {
  const isTestUser = useSelector((state) => state?.user?.isTestUser);
  const [open, setOpen] = useState(false);
  const [showDays, setShowDays] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(7);
  const [selectedYear, setSelectedYear] = useState(2024);
  const [dates, setDates] = useState([]);
  const [activeIcon, setActiveIcon] = useState(null);
  const [showTable, setShowTable] = useState(true);
  const [showGrid, setShowGrid] = useState(false);
  const [workingDays, setWorkingDays] = useState(31);
  const [days, setDays] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [filteredData, setFilteredData] = useState(days);
  const [selectedEmployees, setSelectedEmployees] = useState("");
  const [apiEmployees, setApiEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState("");
  const [clients, setClients] = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [modalSelectedDepartment, setModalSelectedDepartment] = useState(""); // New state for modal
  const [attendanceData, setAttendanceData] = useState([]);
  const [loadingAttendance, setLoadingAttendance] = useState(true); // Start with true to prevent flickering
  const [selectedMonthForData, setSelectedMonthForData] = useState(7);
  const [selectedYearForData, setSelectedYearForData] = useState(2024);
  const [selectedAttendance, setSelectedAttendance] = useState(null); // For showing attendance details

  // Add the missing handler function
  const handleModalDepartmentChange = (event) => {
    setModalSelectedDepartment(event.target.value);
  };

  const handleEmployeesChange = (event) => {
    setSelectedEmployees(event.target.value);
  };

  // Handle employee selection
  const handleEmployeeChange = (event) => {
    setSelectedEmployee(event.target.value);
  };

  useEffect(() => {
    if (selectedEmployee) {
      const newData = days.filter((day) => day.employee === selectedEmployee); // Update with actual filter logic
      setFilteredData(newData);
    } else {
      // Reset to default data if no employee is selected
      setFilteredData(days);
    }
  }, [selectedEmployee, days]);

  // Function to calculate the number of days in the selected month and year
  const calculateDaysInMonth = (month, year) => {
    const numDays = new Date(year, month + 1, 0).getDate(); // Get the last day of the month
    const daysArray = Array.from({ length: numDays }, (_, i) => i + 1); // Create an array of day numbers
    setDays(daysArray);
    setWorkingDays(numDays); // Update the working days
  };

  const getDayOfWeek = (day, month, year) => {
    const date = new Date(year, month, day);
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return daysOfWeek[date.getDay()]; // Get the weekday index and return the name
  };

  useEffect(() => {
    calculateDaysInMonth(selectedMonth, selectedYear);
  }, [selectedMonth, selectedYear]);

  const [selectedDesignation, setSelectedDesignation] = useState("");

  const handleDepartmentChange = (event) => {
    setSelectedDepartment(event.target.value);
  };
  const handleDateChange = (newDate) => {
    // setDate(newDate); // Update the date state
  };
  // Handle designation selection
  const handleDesignationChange = (event) => {
    setSelectedDesignation(event.target.value);
  };

  // Filter employees based on selected employee, designation, and department
  const filteredEmployees = employees.filter((employee) => {
    const matchesEmployee =
      selectedEmployee === "" || employee.name === selectedEmployee;
    const matchesDesignation =
      selectedDesignation === "" || employee.role === selectedDesignation;
    const matchesDepartment =
      selectedDepartment === "" || employee.depart === selectedDepartment;

    return matchesEmployee && matchesDesignation && matchesDepartment;
  });
  useEffect(() => {
    handleListIconClick();
  }, []);
  const handleListIconClick = () => {
    setActiveIcon("list");
    setShowDays(true);
    setShowGrid(false);
    setShowTable(true);
  };

  const handlePersonIconClick = () => {
    setActiveIcon("person");
    setShowGrid(true);
    setShowTable(false);
  };

  const handleWatchLaterIconClick = () => {
    setActiveIcon("watchLater");
    setShowDays(false);
    setShowGrid(false);
    setShowTable(true);
  };

  const buttonStyle = {
    backgroundColor: "#1d82f5",
    "&:hover": { backgroundColor: "orange" },
    textAlign: "center",
    padding: "10px",
    marginLeft: "10px",
    height: "40px",
    width: "170px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    borderRadius: "4px",
    fontSize: "15px",
    fontFamily: "sans-serif",
    cursor: "pointer",
  };

  const iconButtonStyle = (isActive) => ({
    backgroundColor: isActive ? "orange" : "#333", // Dark blue when active
    color: "#fff",
    // transition: "background-color 0.3s ease, transform 0.3s ease",
    borderRadius: "4px",
    maraginRight: "10px",
    "&:hover": {
      backgroundColor: "orange",
      color: "#000", // Hover effect with blue
      // transform: "scale(1.1)",
    },
  });

  useEffect(() => {
    // Calculate the number of days in the selected month and year
    const daysInMonth = getDaysInMonth(selectedMonth, selectedYear);
    setDates(Array.from({ length: daysInMonth }, (_, i) => i + 1));
  }, [selectedMonth, selectedYear]);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    setSelectedMonthForData(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    setSelectedYearForData(event.target.value);
  };

  const [selectedWork, setSelectedWork] = useState("");
  const handleWorkChange = (event) => {
    setSelectedWork(event.target.value);
  };

  const [selectedLocation, setSelectedLocation] = useState("");
  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };

  const [importClicked, setImportClicked] = useState(false);
  const [file, setFile] = useState(null);
  const [hasHeaders, setHasHeaders] = useState(false);

  // Handle file upload
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleToggleChange = () => {
    setHasHeaders(!hasHeaders);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleImportClick = () => {
    setImportClicked(true); // Open the dialog when the import button is clicked
  };

  const onClose = () => {
    setImportClicked(false); // Close the dialog when the back button or outside area is clicked
  };

  const handleExportClick = () => {
    const link = document.createElement("a");
    link.href = "/mnt/data/Attendance_From_01-09-2024_To_25-09-2024.xlsx";
    link.download = "Attendance_From_01-09-2024_To_25-09-2024.xlsx";
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  // Define reusable input styling to match Department style
  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiSelect-select": {
        color: "#424242", // For dropdown selects
      },
      "& .MuiInputBase-input": {
        color: "#424242", // For text and date inputs
      },
    },
  };

  // Fetch departments from the API
  useEffect(() => {
    const fetchDepartments = async () => {
      setLoadingDepartments(true);
      try {
        const response = await departmentHRApi.getAll();
        if (response && response.data) {
          setDepartments(response.data);
        } else {
          console.error("No departments found or empty response");
          setDepartments([]);
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
      } finally {
        setLoadingDepartments(false);
      }
    };

    fetchDepartments();
  }, []);

  // Fetch clients from the API
  useEffect(() => {
    const fetchClients = async () => {
      setLoadingClients(true);
      try {
        const response = await clientApis.getAll(1, 50);
        if (response && response.data && Array.isArray(response.data)) {
          setClients(response.data);
          // Auto-select first client
          if (response.data.length > 0) {
            setSelectedClientId(response.data[0].user_id);
          }
        } else {
          setClients([]);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]);
      } finally {
        setLoadingClients(false);
      }
    };

    fetchClients();
  }, []);

  // Handle client change from header
  const handleClientChange = (clientId) => {
    setSelectedClientId(clientId);
  };

  // Fetch attendance data from API
  const fetchAttendanceData = useCallback(async (clientId) => {
    if (!clientId) return;

    try {
      setLoadingAttendance(true);

      const finalTime = `${selectedYearForData}-${String(selectedMonthForData + 1).padStart(2, "0")}`;

      console.log("Fetching attendance with params:", { clientId, finalTime });

      const result = await clientApis.clientDriverAttendance(clientId, finalTime);

      console.log("Attendance API Result:", result);
      console.log("Attendance API Result type:", typeof result);
      console.log("Attendance API Result is array:", Array.isArray(result));

      if (result && Array.isArray(result)) {
        setAttendanceData(result);
        console.log("Set attendance data with", result.length, "employees");
        if (result.length > 0) {
          console.log("Sample employee data structure:", result[0]);
          console.log("Sample employee attendance:", result[0].attendance);
        }
      } else if (result && result.data && Array.isArray(result.data)) {
        setAttendanceData(result.data);
        console.log("Set attendance data from result.data with", result.data.length, "employees");
        if (result.data.length > 0) {
          console.log("Sample employee data structure:", result.data[0]);
        }
      } else if (result && result.success && result.data && Array.isArray(result.data)) {
        setAttendanceData(result.data);
        console.log("Set attendance data from result.success.data with", result.data.length, "employees");
        if (result.data.length > 0) {
          console.log("Sample employee data structure:", result.data[0]);
        }
      } else {
        console.log("No valid attendance data found, setting empty array");
        console.log("Result structure:", JSON.stringify(result, null, 2));
        setAttendanceData([]);
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setAttendanceData([]);
    } finally {
      setLoadingAttendance(false);
    }
  }, []);

  // Update attendance data when month/year changes
  useEffect(() => {
    if (selectedClientId) {
      console.log("Fetching attendance data for client:", selectedClientId);
      console.log("Month:", selectedMonthForData, "Year:", selectedYearForData);
      fetchAttendanceData(selectedClientId);
    }
  }, [selectedClientId, selectedMonthForData, selectedYearForData]);

  // Set initial loading to false once component is mounted
  useEffect(() => {
    setLoadingAttendance(false);
  }, []);

  // Fetch employees from the API
  useEffect(() => {
    const fetchEmployees = async () => {
      setLoadingEmployees(true);
      try {
        const response = await LeadAgentsSettingsApi.getEmployee();
        if (response) {
          // Ensure response is always an array
          const employeesArray = Array.isArray(response) ? response : [];
          setApiEmployees(employeesArray);
        } else {
          setApiEmployees([]);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
        setApiEmployees([]);
      } finally {
        setLoadingEmployees(false);
      }
    };

    fetchEmployees();
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <AttendenceHeader onClientChange={handleClientChange} initialClientId={selectedClientId} />

      {loadingAttendance ? (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
          gap: 2
        }}>
          <CircularProgress size={50} sx={{ color: '#1976d2' }} />
          <Typography variant="h6" sx={{ color: '#666', fontWeight: 500 }}>
            Loading attendance data...
          </Typography>
        </Box>
      ) : (
      <Box sx={{ marginTop: "30px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            {!isTestUser && (
              <>
                <Box
                  onClick={handleClickOpen}
                  sx={{
                    backgroundColor: "#4285F4",
                    "&:hover": { backgroundColor: "#3367D6", color: "#fff" },
                    textAlign: "center",
                    padding: "10px",
                    marginLeft: "10px",
                    height: "40px",
                    width: "160px",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    borderRadius: "4px",
                    fontSize: "15px",
                    fontFamily: "sans-serif",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  <EventNote /> Mark Attendance
                </Box>

                <Box
                  onClick={handleExportClick}
                  sx={{
                    backgroundColor: "#fff",
                    textAlign: "center",
                    padding: "7px",
                    marginLeft: " 10px",
                    height: "40px",
                    width: " 82px",
                    display: "flex",
                    color: "#333",
                    justifyContent: "space-around",
                    alignItems: " center",
                    borderRadius: " 4px",
                    fontSize: "15px",
                    fontFamily: "sans-serif",
                    cursor: "pointer",
                    border: "1px solid gray",
                    "&:hover": { backgroundColor: "orange" },
                  }}
                >
                  <ImportExport /> Export
                </Box>
              </>
            )}
          </Box>
          {/* Icons to the right of the Export button */}
          <Box
            mr={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={1}
          >
            {/* Month Selector */}
            <Select
              variant="outlined"
              size="small"
              value={selectedMonthForData}
              onChange={(e) => {
                setSelectedMonthForData(e.target.value);
                setSelectedMonth(e.target.value);
              }}
              sx={{
                minWidth: "100px",
                backgroundColor: "#fff",
                color: "#000",
                height: "36px"
              }}
            >
              {months.map((month, index) => (
                <MenuItem key={index} value={index}>
                  {month}
                </MenuItem>
              ))}
            </Select>

            {/* Year Selector */}
            <Select
              variant="outlined"
              size="small"
              value={selectedYearForData}
              onChange={(e) => {
                setSelectedYearForData(e.target.value);
                setSelectedYear(e.target.value);
              }}
              sx={{
                minWidth: "80px",
                backgroundColor: "#fff",
                color: "#000",
                height: "36px"
              }}
            >
              {[2024, 2023, 2022, 2021, 2020].map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>

            <Tooltip title="Summary" arrow>
              <IconButton
                onClick={handleListIconClick}
                sx={{ ...iconButtonStyle(activeIcon === "list") }}
              >
                <ListIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Attendance by Member" arrow>
              <IconButton
                onClick={handlePersonIconClick}
                sx={{ ...iconButtonStyle(activeIcon === "person") }}
              >
                <Person />
              </IconButton>
            </Tooltip>

            <Tooltip title="Attendance by Hour" arrow>
              <IconButton
                onClick={handleWatchLaterIconClick}
                sx={{ ...iconButtonStyle(activeIcon === "watchLater") }}
              >
                <WatchLaterIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        
        {/* Updated Mark Attendance Modal */}
        <Dialog
          fullWidth
          maxWidth="md"
          open={open}
          onClose={handleClose}
          TransitionComponent={Slide}
          PaperProps={{
            style: {
              position: "absolute",
              top: 0,
              right: 0,
              width: "calc(100% - 260px)", // Adjusted width to account for sidebar
              height: "100%",
              backgroundColor: "#f5f5f5",
              margin: 0,
              maxHeight: "100%",
              borderRadius: 0,
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                sx={{ color: "#212121" }}
              >
                <CloseIcon fontSize="large" />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, fontSize: "18px", color: "#212121" }}
                component="div"
              >
                Mark Attendance
              </Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
            <Card sx={{ p: 2, bgcolor: "#ffffff", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)" }}>
              <CardContent>
                <Typography variant="h6" sx={{ color: "#212121", mb: 3 }}>
                  Attendance Details
                </Typography>
                <Divider sx={{ mb: 3 }} />
                
                <Grid container spacing={3}>
                  {/* Department and Employees Selection */}
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Department
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      value={modalSelectedDepartment || ""} // Use the new state variable
                      onChange={handleModalDepartmentChange} // Use the new handler
                      InputProps={inputProps}
                      disabled={loadingDepartments}
                    >
                      <MenuItem value="" disabled>Nothing Selected</MenuItem>
                      {loadingDepartments ? (
                        <MenuItem disabled>
                          <Box display="flex" alignItems="center" gap={1}>
                            <CircularProgress size={20} />
                            <span>Loading departments...</span>
                          </Box>
                        </MenuItem>
                      ) : (
                        departments.map((department) => (
                          <MenuItem key={department.id} value={department.department}>
                            {department.department}
                          </MenuItem>
                        ))
                      )}
                    </TextField>
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Employee
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      value={selectedEmployees}
                      onChange={handleEmployeesChange}
                      InputProps={inputProps}
                      disabled={loadingEmployees}
                    >
                      <MenuItem value="" disabled>
                        <em>Select an employee</em>
                      </MenuItem>
                      {loadingEmployees ? (
                        <MenuItem disabled>
                          <Box display="flex" alignItems="center" gap={1}>
                            <CircularProgress size={20} />
                            <span>Loading employees...</span>
                          </Box>
                        </MenuItem>
                      ) : (
                        apiEmployees.map((employee) => (
                          <MenuItem key={employee.id} value={employee.id}>
                            <Box display="flex" justifyContent="space-between" width="100%">
                              <span>{employee.name}</span>
                              <Typography variant="caption" color="text.secondary">
                                {employee.empid}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))
                      )}
                    </TextField>
                  </Grid>

                  {/* Location and Working From */}
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Location
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      value={selectedLocation || "WorkSuite"}
                      onChange={handleLocationChange}
                      InputProps={inputProps}
                    >
                      <MenuItem value="WorkSuite">WorkSuite</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Working From <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      value={selectedWork || "Office"}
                      onChange={handleWorkChange}
                      InputProps={inputProps}
                    >
                      <MenuItem value="Office">Office</MenuItem>
                      <MenuItem value="Home">Home</MenuItem>
                    </TextField>
                  </Grid>

                  {/* Check In and Check Out */}
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Check In
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            size: "small",
                            InputProps: inputProps
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Check Out
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            size: "small",
                            InputProps: inputProps
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>

                  {/* Year and Month */}
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Year
                    </Typography>
                    <TextField
                      type="number"
                      defaultValue="2024"
                      fullWidth
                      size="small"
                      InputProps={inputProps}
                    />
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Month <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      defaultValue="September"
                      size="small"
                      InputProps={inputProps}
                    >
                      <MenuItem value="January">January</MenuItem>
                      <MenuItem value="February">February</MenuItem>
                      <MenuItem value="March">March</MenuItem>
                      <MenuItem value="April">April</MenuItem>
                      <MenuItem value="May">May</MenuItem>
                      <MenuItem value="June">June</MenuItem>
                      <MenuItem value="July">July</MenuItem>
                      <MenuItem value="August">August</MenuItem>
                      <MenuItem value="September">September</MenuItem>
                      <MenuItem value="October">October</MenuItem>
                      <MenuItem value="November">November</MenuItem>
                      <MenuItem value="December">December</MenuItem>
                    </TextField>
                  </Grid>

                  {/* Additional Options */}
                  <Grid item xs={12}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Additional Options
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" sx={{ color: "#616161", fontSize: "0.9rem" }}>
                            Half Day
                          </FormLabel>
                          <RadioGroup row defaultValue="No">
                            <FormControlLabel
                              value="Yes"
                              control={<Radio sx={{ 
                                color: "#bdbdbd",
                                '&.Mui-checked': {
                                  color: "#4285F4",
                                },
                              }} />}
                              label="Yes"
                              sx={{ color: "#616161" }}
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio sx={{ 
                                color: "#bdbdbd",
                                '&.Mui-checked': {
                                  color: "#4285F4",
                                },
                              }} />}
                              label="No"
                              sx={{ color: "#616161" }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12} md={4}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" sx={{ color: "#616161", fontSize: "0.9rem" }}>
                            Late
                          </FormLabel>
                          <RadioGroup row defaultValue="No">
                            <FormControlLabel
                              value="Yes"
                              control={<Radio sx={{ 
                                color: "#bdbdbd",
                                '&.Mui-checked': {
                                  color: "#4285F4",
                                },
                              }} />}
                              label="Yes"
                              sx={{ color: "#616161" }}
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio sx={{ 
                                color: "#bdbdbd",
                                '&.Mui-checked': {
                                  color: "#4285F4",
                                },
                              }} />}
                              label="No"
                              sx={{ color: "#616161" }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12} md={4}>
                        <Box mt={1}>
                          <FormControlLabel
                            control={<Checkbox sx={{ 
                              color: "#bdbdbd",
                              '&.Mui-checked': {
                                color: "#4285F4",
                              },
                            }} />}
                            label="Attendance Overwrite"
                            sx={{ color: "#616161" }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Box display="flex" gap={2} mt={3}>
                  <Button
                    onClick={handleClose}
                    variant="contained"
                    sx={{
                      bgcolor: "#4285F4",
                      color: "white",
                      "&:hover": { bgcolor: "#3367D6" },
                      fontWeight: 500,
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={handleClose}
                    variant="outlined"
                    sx={{
                      borderColor: "#bdbdbd",
                      color: "#424242",
                      "&:hover": {
                        borderColor: "#9e9e9e",
                        bgcolor: "rgba(0, 0, 0, 0.04)",
                      },
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Dialog>

        {/* Import Attendance Dialog */}
        <Dialog
          open={importClicked}
          onClose={handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Import Attendance</DialogTitle>
          <DialogContent>
            {/* Warning Alert about Date Format */}
            <Alert severity="warning" style={{ marginBottom: "20px" }}>
              Datetime format should be in <strong>Y-m-d H:i:s</strong> (e.g.
              2022-04-21 12:00:00) format. Make sure the date format is correct
              in the excel file.
            </Alert>

            {/* File Upload Field */}
            <div className="file-upload">
              <TextField
                type="file"
                inputProps={{ accept: ".xls, .xlsx, .csv" }} // File types allowed
                onChange={handleFileChange}
                label={file ? file.name : "Choose a file"}
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <CloudUpload style={{ color: "#ccc", fontSize: "30px" }} />
                  ),
                }}
              />
            </div>

            {/* Toggle Switch for Headers */}
            <FormControlLabel
              control={
                <Switch checked={hasHeaders} onChange={handleToggleChange} />
              }
              label="File Contains Headings Row"
            />
          </DialogContent>

          <DialogActions>
            {/* Action Buttons */}
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: "10px" }}
            >
              Upload
            </Button>
            <Button variant="outlined" color="default" onClick={onClose}>
              Back
            </Button>
          </DialogActions>
        </Dialog>

        {/* Attendance Details Dialog */}
        <Dialog
          open={selectedAttendance !== null}
          onClose={() => setSelectedAttendance(null)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            Attendance Details
            <IconButton
              aria-label="close"
              onClick={() => setSelectedAttendance(null)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {selectedAttendance && (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    Employee:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {selectedAttendance.employeeName}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    Employee ID:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {selectedAttendance.employeeId}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    Date:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {selectedAttendance.date}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">
                    Status:
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    sx={{
                      color: selectedAttendance.status === "1" ? "#4caf50" :
                             selectedAttendance.status === "1603" ? "#f44336" :
                             selectedAttendance.status === "1610" ? "#333" :
                             selectedAttendance.status === "1612" ? "#9c27b0" :
                             selectedAttendance.status === "1605" ? "#ff9800" : "#1976d2"
                    }}
                  >
                    {selectedAttendance.statusText}
                    {selectedAttendance.status === "1" && selectedAttendance.pic === "1" && " (No Location)"}
                  </Typography>
                </Grid>
                {selectedAttendance.check_in_time && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">
                      Check In:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {selectedAttendance.check_in_time}
                    </Typography>
                  </Grid>
                )}
                {selectedAttendance.check_out_time && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">
                      Check Out:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {selectedAttendance.check_out_time}
                    </Typography>
                  </Grid>
                )}
                {selectedAttendance.address && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">
                      Address:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {selectedAttendance.address}
                    </Typography>
                  </Grid>
                )}
                {selectedAttendance.lat && selectedAttendance.lng && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">
                      Location:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {selectedAttendance.lat.substring(0, 8)}, {selectedAttendance.lng.substring(0, 8)}
                    </Typography>
                  </Grid>
                )}
                {selectedAttendance.working_hours && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">
                      Working Hours:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {selectedAttendance.working_hours}
                    </Typography>
                  </Grid>
                )}
                {selectedAttendance.remarks && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                      Remarks:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {selectedAttendance.remarks}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSelectedAttendance(null)} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

      {/* Conditionally render Attendance Table */}
      <Box mt={1}></Box>
      {showTable && (
        <TableContainer
          component={Paper}
          sx={{
            bgcolor: "#fff",
            color: "#000",
            width: "100%",
            "&::-webkit-scrollbar": {
              width: "8px", // Set the minimum width of the scrollbar
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "gray", // Scrollbar thumb color
              borderRadius: "10px", // Rounded corners
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1", // Scrollbar track color
            },
            "scrollbar-color": "gray #f1f1f1", // For Firefox
            "scrollbar-width": "thin", // For Firefox, thin scrollbar
          }}
        >
          <Table sx={{ borderCollapse: "collapse", width: "100%" }}>
            <TableHead>
              {/* Icons and Descriptions Row */}
              <TableRow>
                <TableCell colSpan={36}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: "1rem",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        display: "flex",
                        alignItems: "center",
                        color: "#000",
                      }}
                    >
                      Legend:
                    </Typography>
                    {/* Legend of symbols - matching normal attendance implementation */}
                    <Box display="flex" gap={3}>
                      {Object.entries(statusConfig).map(([key, config]) => (
                        <Typography
                          key={key}
                          variant="body2"
                          sx={{
                            fontSize: "1rem",
                            display: "flex",
                            alignItems: "center",
                            color: "#000",
                          }}
                        >
                          <span style={{ marginRight: "4px", color: config.color, fontWeight: "bold" }}>
                            {config.icon}
                          </span>
                          - {config.label}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>

              {/* Dates Row */}
              <TableRow sx={{ backgroundColor: "#f0f5ff" }}>
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    Employee
                  </Typography>
                </TableCell>
                {dates.map((date) => (
                  <TableCell
                    key={date}
                    align="center"
                    sx={{
                      fontSize: "0.75rem",
                      padding: "0px",
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    {date}
                  </TableCell>
                ))}
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    Total
                  </Typography>
                </TableCell>
              </TableRow>

              {/* Day Names Row */}
              {showDays && (
                <TableRow sx={{ backgroundColor: "#fff" }}>
                  <TableCell />
                  {dates.map((date) => (
                    <TableCell
                      key={date}
                      align="center"
                      sx={{
                        fontSize: "0.75rem",
                        padding: "0px",
                        color: "gray",
                        fontWeight: "bold",
                      }}
                    >
                      {getDayName(date, selectedMonthForData, selectedYearForData)}{" "}
                      {/* Correct day for each date */}
                    </TableCell>
                  ))}
                  <TableCell />
                </TableRow>
              )}
            </TableHead>

            <TableBody>
              {loadingAttendance ? (
                <TableRow>
                  <TableCell colSpan={36} align="center">
                    <Box sx={{ py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <CircularProgress size={40} />
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        Loading attendance data...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : attendanceData.length > 0 ? (
                attendanceData.map((employee, idx) => (
                <TableRow
                  key={idx}
                  sx={{ "&:hover": { backgroundColor: "#e0f7fa" } }}
                >
                  <TableCell sx={{ fontSize: "0.75rem", padding: "7px" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <img
                        src={employee.pic && employee.pic !== "1" && employee.pic !== "non" ? `${config.apiImageUrl}${employee.pic}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(employee.username || employee.name || 'D')}&background=random`}
                        alt={`${employee.username || employee.name} avatar`}
                        style={{
                          borderRadius: "50%",
                          marginRight: "4px",
                          width: "30px",
                          height: "30px",
                          border: "2px solid #1976d2",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(employee.username || employee.name || 'D')}&background=random`;
                        }}
                      />
                      <Box display="flex" flexDirection="column">
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            color: "#000",
                          }}
                        >
                          {employee.username || employee.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "0.65rem", color: "gray" }}
                        >
                          {employee.driver_id || employee.empid}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  {dates.map((date) => {
                    // Use the same function as normal attendance to get attendance for date
                    const attendance = getAttendanceForDate(employee.attendance || [], date, selectedMonthForData, selectedYearForData);

                    console.log(`Attendance for ${employee.username || employee.name} on ${date}:`, attendance);
                    console.log(`Employee attendance array:`, employee.attendance);

                    // Check if present record has pic = "1" (keyboard icon logic)
                    const hasPicOne = attendance && attendance.status === "1" && attendance.pic === "1";

                    // Get status configuration - handle both string and number status
                    let statusItem = null;
                    if (attendance) {
                      console.log(`Attendance status: ${attendance.status} (type: ${typeof attendance.status})`);
                      console.log(`Checking statusConfig[${attendance.status}]:`, statusConfig[attendance.status]);
                      statusItem = statusConfig[attendance.status];
                      console.log(`Found statusItem:`, statusItem);
                    }

                    // Use keyboard icon for present records with pic = "1"
                    if (hasPicOne) {
                      statusItem = statusConfig["1_no_loc"];
                    }

                    return (
                      <TableCell
                        key={date}
                        align="center"
                        sx={{
                          fontSize: "0.75rem",
                          padding: "4px",
                          cursor: attendance ? "pointer" : "default",
                          backgroundColor: hasPicOne
                            ? statusConfig["1_no_loc"]?.bgColor
                            : attendance && statusItem
                            ? statusItem.bgColor
                            : "transparent",
                          "&:hover": attendance ? { backgroundColor: "#f5f5f5" } : {}
                        }}
                        onClick={() => {
                          if (attendance) {
                            console.log("Setting selected attendance:", attendance);
                            console.log("Status item:", statusItem);
                            console.log("Status text:", statusItem?.label || "Unknown");
                            setSelectedAttendance({
                              ...attendance,
                              employeeName: employee.username || employee.name,
                              employeeId: employee.driver_id || employee.empid,
                              statusText: statusItem?.label || "Unknown",
                              originalStatus: attendance.status
                            });
                          }
                        }}
                      >
                        {statusItem ? (
                          <Tooltip title={`${statusItem.label} - Click for details`}>
                            <span style={{
                              fontSize: "1rem",
                              marginRight: "2px",
                              color: statusItem.color,
                              fontWeight: "bold"
                            }}>
                              {statusItem.icon}
                            </span>
                          </Tooltip>
                        ) : (
                          <Tooltip title="No Attendance Record">
                            <CloseIcon
                              sx={{
                                fontSize: "1rem",
                                color: "#f44336",
                                marginRight: 1,
                              }}
                            />
                          </Tooltip>
                        )}
                      </TableCell>
                    );
                  })}
                  <TableCell
                    align="center"
                    sx={{
                      fontSize: "0.75rem",
                      padding: "4px",
                      color: "gray",
                    }}
                  >
                    {/* Calculate present days for this employee */}
                    {(() => {
                      let presentCount = 0;
                      if (employee.attendance && Array.isArray(employee.attendance)) {
                        presentCount = employee.attendance.filter(att => {
                          const attDate = att.date;
                          const formattedDate = `${selectedYearForData}-${String(selectedMonthForData + 1).padStart(2, "0")}`;

                          // Handle both string and number status
                          const status = String(att.status);

                          // Check if status indicates presence (using existing status codes)
                          const isPresent = status === "1";

                          return attDate && attDate.startsWith(formattedDate) && isPresent;
                        }).length;
                      }
                      return <Typography variant="body2">{presentCount}/{dates.length}</Typography>;
                    })()}
                  </TableCell>
                </TableRow>
              ))
              ) : (
                <TableRow>
                  <TableCell colSpan={36} align="center">
                    <Box sx={{ py: 4 }}>
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        No attendance data found for selected client and period
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Box
        mt={1}
        sx={{
          overflowY: "auto",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "gray",
            borderRadius: "10px",
            border: "2px solid #f1f1f1",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "darkgray",
          },
        }}
      >
        {showGrid && (
          <Box sx={{ marginTop: 0 }}>
            <Grid container spacing={2}>
              {stats.map((stat) => (
                <Grid item xs={6} sm={4} md={1.9} key={stat.title}>
                  <Box
                    sx={{
                      textAlign: "center",
                      margin: "5px 0 0 5px",

                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "4px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{
                        fontWeight: "bold",
                        color: "#333",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      {stat.title === "Working Days"
                        ? "Working Days"
                        : stat.title === "Absent"
                        ? "Absent"
                        : stat.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        color: "gray",
                        display: "flex",
                        justifyContent: "right",
                      }}
                    >
                      <CalendarTodayIcon />
                    </Typography>
                    <Typography
                      variant="h6"
                      color="primary"
                      sx={{
                        fontWeight: 600,
                        color: "#1d82f5",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      {stat.title === "Working Days" || stat.title === "Absent"
                        ? workingDays
                        : stat.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
            {/* Attendance Table */}
            <Box
              sx={{
                marginTop: 3,
                backgroundColor: "white",
                padding: 3,
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              {/* Filter Section */}
              <Grid container spacing={2} ml={3} mb={2}>
                {/* Employee Filter Dropdown */}
                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="#000"
                      sx={{
                        fontSize: "1rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <PersonIcon sx={{ marginRight: 0.5, fontSize: "20px" }} />{" "}
                      Employee:
                    </Typography>
                    <Select
                      variant="outlined"
                      size="small"
                      value={selectedEmployees}
                      onChange={handleEmployeesChange}
                      displayEmpty
                      sx={{
                        marginLeft: 0.5,
                        minWidth: "60px",
                        backgroundColor: "#fff",
                        color: "#000",
                      }}
                    >
                      {employees.map((employee) => (
                        <MenuItem key={employee.name} value={employee.name}>
                          {employee.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="#000"
                      sx={{
                        fontSize: "1rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <EventIcon sx={{ marginRight: 0.5, fontSize: "20px" }} />{" "}
                      Month:
                    </Typography>
                    <Select
                      variant="outlined"
                      size="small"
                      value={selectedMonth}
                      onChange={handleMonthChange}
                      sx={{
                        marginLeft: 0.5,
                        minWidth: "80px",
                        backgroundColor: "#fff",
                        color: "#000",
                      }}
                    >
                      {[
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                      ].map((month, index) => (
                        <MenuItem key={index} value={index}>
                          {month}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>

                {/* Year Selector */}
                <Grid item xs={12} sm={4}>
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="#000"
                      sx={{
                        fontSize: "1rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CalendarTodayIcon
                        sx={{ marginRight: 0.5, fontSize: "20px" }}
                      />{" "}
                      Year:
                    </Typography>
                    <Select
                      variant="outlined"
                      size="small"
                      value={selectedYear}
                      onChange={handleYearChange}
                      sx={{
                        marginLeft: 0.5,
                        minWidth: "60px",
                        backgroundColor: "#fff",
                        color: "#000",
                      }}
                    >
                      {[2024, 2023, 2022, 2021, 2020].map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>
              </Grid>

              {/* Attendance Table */}
              <table
                style={{
                  width: "100%",
                  textAlign: "center",
                  borderCollapse: "collapse",
                  fontFamily: "'Roboto', sans-serif",
                }}
              >
                <thead>
                  <tr>
                    {[
                      "Date",
                      "Status",
                      "Clock In",
                      "Clock Out",
                      "Total",
                      "Others",
                    ].map((header) => (
                      <th
                        key={header}
                        style={{
                          padding: "12px",
                          borderBottom: "2px solid #1976d2",
                          backgroundColor: "#f5f5f5",
                          color: "#1976d2",
                          fontWeight: "bold",
                        }}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((day) => (
                    <tr key={day.date}>
                      <td
                        style={{
                          padding: "12px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#333",
                          }}
                        >
                          {String(day).padStart(2, "0")}-
                          {String(selectedMonth + 1).padStart(2, "0")}-
                          {selectedYear}
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#888",
                          }}
                        >
                          {getDayOfWeek(day, selectedMonth, selectedYear)}
                        </div>
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          borderBottom: "1px solid #ddd",
                          color: "red",
                          // fontWeight: "bold",
                        }}
                      >
                        Absent
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        -
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        -
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        -
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        -
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Box>
        )}
      </Box>
      </Box>
      )}
      </Box>
    );
  };

export default Attendance;
